import React from "react";
import { useTranslation } from "react-i18next";

import { Box, BackgroundImage, Stack, Title } from "@mantine/core";

import backgroundImg from "src/assets/images/start_background.png";

import cx from "./start_page.module.css";
import { useColors } from "@utils/useColors";
import clsx from "clsx";

import {
  useParsedAcctActivationQueryParam,
  useCreateAccountQuery,
} from "src/services/accountActivation/createAccountQuery";

import { useCheckoutTracking } from "src/services/accountActivation/checkoutTracking";

import { useStartPageConfig } from "src/services/accountActivation/startPageConfig";

// VIEWS
import { AccountActiveError } from "./views/AccountActivateError";
import { AccountActivateLoading } from "./views/AccountActivateLoading";
import { AccountActivateView } from "./views/AccountActivateView/AccountActivateView";

export const StartIndexPage = React.memo(function StartIndexPage() {
  const { t } = useTranslation();
  const colors = useColors();

  const paramParseResult = useParsedAcctActivationQueryParam();

  useCheckoutTracking();

  const {
    data: apiResp,
    isLoading: _isLoading,
    isError: isQueryError,
  } = useCreateAccountQuery();

  const startPageConfig = useStartPageConfig();

  const isLoading = !apiResp || _isLoading;
  const isError = isQueryError || paramParseResult.isError;

  return (
    <Box bg={colors.royal100} className={cx["outer-wrapper"]}>
      <BackgroundImage src={backgroundImg} className={cx["background-image"]}>
        <Stack className={cx["page-wrapper"]}>
          <Title
            className={clsx(cx["page-header"], cx["text-center"])}
            c={colors.royal100}
          >
            {t("startPage.pageHeader")}
          </Title>

          <div className={cx["content-container"]}>
            {isError ? (
              <AccountActiveError />
            ) : isLoading || !startPageConfig ? (
              <AccountActivateLoading />
            ) : (
              <AccountActivateView
                startPageConfig={startPageConfig}
                accountCreateResp={apiResp}
              />
            )}
          </div>
        </Stack>
      </BackgroundImage>
    </Box>
  );
});
